<template>
<div id="index" :class="arChannel?'ar-channel-style':''">
  <div v-show="!point" class="banner"  @click="openPoint">
    <img src="../img/ar-top.jpg" alt="">
    <button type="button" name="button" class="btn ar-btn"></button>
  </div>
  <div v-show="point" class="banner big-btn"  @click="getInvite">
    <img  src="../img/ar-top.jpg" alt="">
    <button type="button" name="button" class="btn ar-btn"></button>
  </div>
  <img src="../img/ar-bottom.jpg" alt="">
  <img src="../img/look.png" alt="" v-show="look" class="look look-btn" @click="lookAuth">
  <div class="rule" @click="gotoRule">活动规则</div>
  <div class="point active-bg">
    <van-popup v-model="pointShow" class="packet-popup" :close-on-click-overlay="false" :lazy-render="false">
      <div class="popup-wrap" >
        <div class="popup-content">
          <button type="button" class="jump big-btn" name="button">跳过</button>
          <div class="info big-btn"  @click="closePoint" >
            <img v-show="active===1" :src="$state.configInfo.step1" alt>
            <img v-show="active===2" :src="$state.configInfo.step2" alt>
            <img v-show="active===3" :src="$state.configInfo.step3" alt>
            <img v-show="active===4" :src="$state.configInfo.step4" alt>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</div>
</template>

<script>
import {
  isAlipay,
  isWechat,
  getQueryString
} from 'common/js/util'
import { checkAuth } from 'common/js/api'
export default {
  name: 'index',
  data() {
    return {
      point: false,
      pointShow:false,
      arChannel:false,
      active:1,
      look:true
    }
  },
  created() {
    this.point = this.$storejs.get(`${this.$key}point`) || false
    if(getQueryString('mid')==='5381zdgu1kjgjnkaopmqsygb'){
      this.arChannel=true
    }
    if(getQueryString('mid')==='70g3i2ydkqhytbiukktg9n5aop'){
      window.location.href = "alipays://platformapi/startApp?appId=2017101709350139&page=pages/index/index"
    }
  },
  mounted() {
    this.initAr()
    this.lookAuth()
  },
  methods: {
    openPoint() {
      this.pointShow = true
      this.$storejs.set(`${this.$key}point`, true)
      this.point = true
      this.getInvite()
      setTimeout(()=>{
        this.active=2
      },3000)
      setTimeout(()=>{
        this.active=3
      },5000)
      setTimeout(()=>{
        this.active=4
      },7000)
    },
    closePoint() {
      this.pointShow = false
    },
    lookAuth(){
      const url = encodeURIComponent(`alipays://platformapi/startapp?appId=2018041102537137&page=pages/search_result/search_result&query=picUrl%3Dhttps%3A%2F%2Fimgqn.pcauto.com.cn%2Fimages%2Fupload%2Fupc%2Ftx%2Fqn%2Fbbs6%2F1811%2F23%2Fc565%2Fundefined_1542940441446.jpg%3FimageMogr2%2Fauto-orient%2Fstrip%2Fthumbnail%2F!520x390r%2Fgravity%2FCenter%2Fcrop%2F520x390%2Fquality%2F60`)
      const openalipay = new Openalipay({
        url,
        targets: '.look-btn',
        useTransfer: true,
        callback: () => {
          // 统计信息
          let label
          if (isAlipay) {
            label = '支付宝'
          } else if (isWechat) {
            label = '微信'
          } else {
            label = '其他'
          }
          typeof _hmt !== 'undefined' && _hmt.push(['_trackEvent',`${this.$key}`,'推广页跳游戏页', `${label}授权`])
        }
      })
      openalipay.init()
    },
    initAr() {
      const url = encodeURIComponent(`alipays://platformapi/startapp?appId=10000007&selectedTab=ar&showOthers=YES`)
      const openalipay = new Openalipay({
        url,
        targets: '.big-btn',
        useTransfer: true,
        callback: () => {
          // // 统计信息
          let label
          if (isAlipay) {
            label = '支付宝'
          } else if (isWechat) {
            label = '微信'
          } else {
            label = '其他'
          }
          typeof _hmt !== 'undefined' && _hmt.push(['_trackEvent',`${this.$key}`,'ar跳转', `${label}授权`])
        }
      })
      openalipay.init()
    },
    async getInvite() {
      const invite = this.$storejs.get(`${this.$key}Invite`)
      if (invite && this.$env === 'prod') {
        return
      }
      if (!getQueryString('mid')) {
        return
      }
      const res = await this.$post({
        baseURL: this.$baseURL.cat,
        url: '/activity/arsc190521/invite',
        data: {
          mid: getQueryString('mid')
        },
        loading: false
      })
      if (res.code === 0) {
        this.$storejs.set(`${this.$key}Invite`, true)
      } else {
        this.$toast(res.msg)
      }
    },
    gotoRule() {
      window.location.href = `${this.$baseURL.cat}/dist/arsc190521/rule.html${window.location.search}`
    }
  }
}
</script>

<style lang="scss">
body {
    background: #171834;
    font-size: 32px;
}
.ar-channel-style{
  margin-top:120px;
}
.ar-channel-style .look{
  top:800px;
}
.look{
  position:fixed;
  width:189px;
  height:160px;
  top:720px;
  right:-10px;
  animation: btnScale 1.2s infinite ease-in;
}
.banner {
    width: 750px;
    height: 1070px;
    position: relative;
    overflow: hidden;
}
.point /deep/ .van-overlay {
    background-color: rgba(0, 0, 0, 0.75);
}
img {
    width: 750px;
}
.rule {
    width: 750px;
    height: 180px;
    line-height: 180px;
    color: #46fff1;
    text-align: center;
    text-shadow: 0 0 30px rgba(70,255,241,0.6);
    background: url("../img/btn3.png") no-repeat center center;
    background-size: 300px 85px;
    font-size: 30px;
}
.ar-btn{
  width:100%;
  height:115px;
  background: url("../img/btn10.png") center/contain no-repeat;
  border:0;
  position: absolute;
  bottom:50px;
  transform-origin: center center;
  animation: btnScale 1.2s infinite ease-in;
}
.popup-wrap {
    height: 100vh;
    width: 750px;
    position: relative;
    background: rgba(0,0,0,0.8);
    .jump {
        border: 1px solid #fff;
        background: transparent;
        color: #fff;
        height: 50px;
        border-radius: 25px;
        width: 120px;
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .next {
        width: 150px;
    }
    .ok {
        width: 200px;
    }
    .button {
        border: 0;
        color: #fff;
        background: url("../img/btn6.png") center/contain no-repeat;
        width: 501px;
        height: 104px;
        line-height: 104px;
    }
}
</style>
